import { fetchArticle } from '@/redux/modules/article/article.actions';
import { getArticle } from '@/redux/modules/article/article.selectors';
import { beginArticleLinksNavigation } from '@/redux/modules/articleLinks/articleLinks.actions';
import { fetchArticleLinksIfCurrent } from '@/redux/modules/articleLinks/articleLinks.loader';
import { DataLoaderParams } from '@/types/DataLoaderParams';

import { getArticlePageLinksParams } from './getArticlePageLinksParams';

/**
 * Loads article data for `/guides/:topic/:slug`.
 */
export const articlePageData = async ({
    amplitudeExperimentFlags,
    match: { params },
    store: { dispatch, getState },
}: DataLoaderParams) => {
    const { slug, topic } = params;

    if (!topic || !slug) {
        return;
    }

    const articleLinksNavigationId = dispatch(beginArticleLinksNavigation());

    await dispatch(fetchArticle({ slug, topic }));

    const article = getArticle(getState());
    await fetchArticleLinksIfCurrent({
        amplitudeExperimentFlags,
        dispatch,
        getState,
        navigationId: articleLinksNavigationId,
        params: getArticlePageLinksParams(article),
    });
};
